import { WalletTabEnum } from '@/components/Modals/WalletModal/WalletModal';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { create } from 'zustand';
import { useShallow } from 'zustand/shallow';

/* -------------------------------------------------------------------------- */

export enum ModalStatusEnum {
	RedeemPromoModal = 'RedeemPromoModal',
	ForfeitedBonusModal = 'ForfeitedBonusModal',
	SearchModal = 'SearchModal',
	WalletModal = 'WalletModal',
	VerificationLevel1 = 'VerificationLevel1',
	AdditionalVerification = 'AdditionalVerification',
	GeoBlockModal = 'GeoBlockModal',

	LevelUpModal = 'LevelUpModal',
	VipPropertyPreview = 'VipPropertyPreview',
	VipRewardPreview = 'VipRewardPreview',

	DepositLimitKYC2Modal = 'DepositLimitKYC2Modal',
}

interface ModalStore {
	modalStatus: ModalStatusEnum | null;
	actions: {
		setModalStatus: (modalType: ModalStatusEnum | null) => void;
		openWalletModal: (tab: WalletTabEnum, router: AppRouterInstance) => void;
	};
}

const modalStore = create<ModalStore>((set) => ({
	// modalStatus: ModalStatusEnum.LevelUpModal,
	modalStatus: null,

	/* -------------------------------------------------------------------------- */

	actions: {
		setModalStatus: (modalType: ModalStatusEnum | null) => {
			set(() => ({
				modalStatus: modalType,
			}));
		},
		openWalletModal: (walletTab: WalletTabEnum, router: AppRouterInstance) => {
			const url = new URL(window.location.href);
			url.searchParams.set('wallet', walletTab);
			router.push(url.pathname + url.search);
			set(() => ({
				modalStatus: ModalStatusEnum.WalletModal,
				walletTab,
			}));
		},
	},
}));

export const useModalStatus = () =>
	modalStore(useShallow((state) => state.modalStatus));

export const useModalStoreActions = () => modalStore((state) => state.actions);
